<div [formGroup]="form" [hidden]="isHidden">
  @switch (formElement.controlType) {
    @case ('checkbox') {
      <mat-checkbox [formControlName]="formElement.key" [aria-label]="formElement.ariaLabel | translate"
        >{{ formElement.label | translate }}
      </mat-checkbox>
    }
    @case ('datepicker') {
      <mat-form-field>
        <mat-label>{{ formElement.label | translate }}</mat-label>
        <input
          matInput
          [matDatepicker]="picker"
          [formControlName]="formElement.key"
          (dateChange)="onDateChange($event, formElement.key)" />
        @if (formElement.hint) {
          <mat-hint>{{ formElement.hint | translate }}</mat-hint>
        }
        <mat-datepicker-toggle matIconSuffix [for]="picker" />
        <mat-datepicker #picker />
      </mat-form-field>
    }
    @case ('textbox') {
      @if (formElement.type === 'email' || formElement.type === 'text') {
        <portal-text-input
          [errors]="formElement.errors"
          [formControlName]="formElement.key"
          [hint]="formElement.hint"
          [label]="formElement.label"
          [id]="formElement.key"
          [placeholder]="formElement.placeholder"
          [type]="formElement.type" />
      } @else if (formElement.type === 'number') {
        <portal-number-input
          [errors]="formElement.errors"
          [formControlName]="formElement.key"
          [hint]="formElement.hint"
          [label]="formElement.label"
          [id]="formElement.key"
          [min]="formElement.min"
          [max]="formElement.max"
          [placeholder]="formElement.placeholder" />
      } @else {
        <mat-form-field>
          <mat-label>{{ formElement.label | translate }}</mat-label>
          <input matInput [formControlName]="formElement.key" [id]="formElement.key" [type]="formElement.type" />
        </mat-form-field>
      }
    }
    @case ('radio') {
      <mat-radio-group [formControlName]="formElement.key" [attr.aria-label]="formElement.ariaLabel | translate">
        @for (option of formElement.options; track option.key) {
          <mat-radio-button [value]="option.value">{{ option.label | translate }}</mat-radio-button>
        }
      </mat-radio-group>
    }
    @case ('header-only') {
      <h2>{{ formElement.label | translate }}</h2>
    }
    @case ('text-only') {
      <p>{{ formElement.label | translate }}</p>
    }
    @case ('text-only-html') {
      <p [innerHTML]="formElement.label | translate"></p>
    }
  }
</div>
